export const activities = [
    'skitouring',
    'walking',
    'running',
    'cycling',
    'hiking'
]